import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface AnalyticsDescriptionIconProps {
  description: string;
  className?: string;
}

export default function AnalyticsDescriptionIcon(props: AnalyticsDescriptionIconProps): JSX.Element {
  return (
    <Tooltip placement={TooltipPlacement.BOTTOM} title={props.description}>
      <BenchlingIcon icon="info-circle" className={classNames(props.className, css(styles.largerIcon))} />
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  largerIcon: {
    transform: 'translateY(1px)',
    width: '14px',
    height: '14px',
    marginBottom: '0px',
  },
});
